module.exports = __webpack_public_path__ + "static/White-market-transp-logo-fabf7cfa91cac2141954851791d126a5.png";